// eslint-disable-next-line import/no-anonymous-default-export
export default (category = [], action) => {
  switch (action.type) {
    case "FETCH_ALL":
      return action.payload;

    case "CREATE_CATEGORY":
      return [...category, action.payload];

    default:
      return category;
  }
};
